module.exports = {
        srcSet: __webpack_public_path__ + "static/media/rent_legal_mobile-639.f10e8884.webp"+" 639w",
        images: [{path: __webpack_public_path__ + "static/media/rent_legal_mobile-639.f10e8884.webp",width: 639,height: 427}],
        src: __webpack_public_path__ + "static/media/rent_legal_mobile-639.f10e8884.webp",
        toString: function(){return __webpack_public_path__ + "static/media/rent_legal_mobile-639.f10e8884.webp"},
        
        width: 639,
        height: 427
      }